// extracted by mini-css-extract-plugin
module.exports = {"upgradePlanSection":"UpgradeButton_upgradePlanSection__2Jiqj","upgradePlanButton":"UpgradeButton_upgradePlanButton__2O09Q"};